import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { RecentTravelsItems, Skeleton } from '../../../../component';
import { AirPlaneTicketIcon } from '../../../../content/svg-component';
import './recentTravels.scss';

function RecentTravels({ flightData, language, intl, loadingData }) {
  const { direction } = language,
    headerList = [
      {
        id: 'booking.guest',
        class: `${
          direction === 'rtl'
            ? 'col-sm-5 col-3'
            : 'col-xxl-5 col-lg-4 col-sm-5 col-3'
        }`,
      },
      { id: 'booking.serviceType', class: 'col-3' },
      {
        id: 'booking.count',
        class: `${
          direction === 'rtl'
            ? 'col-2 mx-xs-0 mx-1'
            : 'col-xxl-2 col-lg-1 col-2 mx-xs-0 mx-1'
        }`,
      },
      { id: 'profile.totalAmount', class: 'col-xs-2 col-3' },
    ],
    skeletonList = [...Array(3).keys()];
  return (
    <div className="col-lg-8 col-12 px-2">
      <div className="px-md-1 w-100 h-100">
        <div className="h-100 w-100 d-flex flex-column default-border-radius-small bg-white p-4 border border-third-light">
          <div className="d-flex flex-column align-items-start">
            <FormattedMessage id="profile.recentTravels" />

            <span className="text-third font-md-xsmall font-smaller pb-3 pt-2">
              <FormattedMessage id="profile.mounthReport" />
            </span>
          </div>
          <div className="d-flex w-100 justify-content-around align-items-center font-weight-light pb-3 font-small">
            {flightData.length > 0 &&
              headerList.map((item, key) => {
                return (
                  <div
                    className={`${item.class} ${
                      direction === 'rtl'
                        ? 'font-xl-small font-lg-msmall font-sm-small font-msmall'
                        : 'font-xl-smaller font-lg-xsmall font-sm-msmall font-smaller'
                    } px-0 text-center text-nowrap `}
                    key={`recent-travels-${key}`}
                  >
                    <span
                      className={`position-relative ${
                        item.id === 'booking.count'
                          ? `count-design-${direction}`
                          : item.id === 'booking.serviceType' &&
                            `serviceType-design-${direction}`
                      }`}
                    >
                      <FormattedMessage id={item.id} />
                    </span>
                  </div>
                );
              })}
          </div>
          <div className="w-100 d-flex flex-fill flex-column justify-content-start">
            {flightData.length > 0 ? (
              flightData.map((item, index) => {
                return (
                  <React.Fragment key={`flights-${index}`}>
                    <RecentTravelsItems
                      style="py-3"
                      flightValue={item}
                      language={language}
                      intl={intl}
                    />
                  </React.Fragment>
                );
              })
            ) : loadingData ? (
              <>
                <div className="w-100 h-100 d-flex flex-column align-items-center">
                  {skeletonList.map((item, index) => {
                    return (
                      <React.Fragment key={`flights-${index}`}>
                        <div
                          className={`w-100 d-flex align-items-center justify-content-between position-relative py-3`}
                          style={{
                            borderTop: '1.5px dashed var(--third)',
                            fontSize: '0.8vw',
                          }}
                        >
                          <div className="d-flex align-items-center px-0 col-5">
                            <div className="col-4 px-0">
                              <Skeleton
                                className="img-fluid img-responsive px-0"
                                variant="circle"
                                width="2rem"
                                height="2rem"
                              />
                            </div>
                            <div
                              className={`d-flex flex-column text-center font-xl-msmall font-lg-smaller font-sm-msmall font-xs-smaller font-xsmall col-md-10 col-9 px-2 text-nowrap`}
                            >
                              <div className="d-flex flex-row">
                                <Skeleton className="col-10" variant="text" />
                              </div>
                            </div>
                          </div>
                          <div className="col-3 d-flex flex-row justify-content-center px-0 font-xl-msmall font-lg-smaller font-sm-msmall font-xs-smaller font-xsmall text-nowrap">
                            <Skeleton className="col-10" variant="text" />
                          </div>
                          <div className=" text-white col-2 px-0 d-flex align-items-center justify-content-center">
                            <Skeleton
                              className="img-fluid img-responsive px-0"
                              variant="circle"
                              width="2rem"
                              height="2rem"
                            />
                          </div>
                          <div
                            className={`col-2 px-0 text-center font-xl-msmall font-lg-smaller font-msmall`}
                          >
                            <Skeleton className="col-10 px-2" variant="text" />
                          </div>
                          <div
                            className="position-absolute bg-third-light rounded-circle "
                            style={{
                              padding: '0.8rem',
                              top: -13,
                              right: -38,
                            }}
                          ></div>
                          <div
                            className="position-absolute bg-third-light rounded-circle "
                            style={{ padding: '0.8rem', top: -13, left: -38 }}
                          ></div>
                        </div>
                      </React.Fragment>
                    );
                  })}
                  <span className="font-large text-third">
                    <FormattedMessage id="profile.firsttravel" />
                  </span>
                </div>
              </>
            ) : (
              <div className="d-flex flex-column justify-content-center align-items-center text-nowrap">
                <AirPlaneTicketIcon size={74} color={'#aaacaf'} />
                <span className="pt-2 text-danger text-start font-sm-normal font-msmall">
                  <FormattedMessage id="profile.notfoundtravel" />
                </span>
                <span className="pt-2 text-third text-start font-sm-normal font-msmall">
                  <FormattedMessage id="profile.waitingTrip" />
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

RecentTravels.propTypes = {};

export default injectIntl(RecentTravels);
